/**
 * @generated SignedSource<<d3ca082403f77fe41bd500cb1fbcc17e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueViewBase_Date$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FieldEditIcon">;
  readonly " $fragmentType": "main_issueViewBase_Date";
};
export type main_issueViewBase_Date$key = {
  readonly " $data"?: main_issueViewBase_Date$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueViewBase_Date">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueViewBase_Date",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "FieldEditIcon"
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "5ad08bef4e4295c77c3fcb98119ffe26";

export default node;
